import { render } from "./ResetPassword.view.vue?vue&type=template&id=0d786540"
import script from "./ResetPassword.view.vue?vue&type=script&lang=js"
export * from "./ResetPassword.view.vue?vue&type=script&lang=js"

import "./ResetPassword.view.vue?vue&type=style&index=0&id=0d786540&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__